import { getCdnUrl } from "@/core/helpers/getCdnUrl";

const cdnUrl = getCdnUrl();

export default class VehicleCdn {
  static getVehicleImage(model: string) {
    return `${cdnUrl}images/vehicles/${model}.png`;
  }

  static getVehicleBrandImage(brand: string) {
    return `${cdnUrl}images/vehicle-brands/${brand}.png`;
  }
}
